export const route = {
	home: '/',
	login: 'login',
	orders: 'orders',
	ordersDetail: 'orders/detail',
	account: 'account',
	accountPassword: 'account/update-password',
	accountTopUps: 'account/top-ups',
	cart: 'cart',
	cartItem: 'cart/item',
	item: 'item',
	notification: 'notification',
	accountTopUp: 'account/top-up',
};
